<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import { loadGLTF } from '../../Reusable/loadGLTF'
import { WoozyMaterial } from '../../Reusable/WoozyMaterial.js'
// import { MeshBasicMaterial } from 'three'

export default {
  mixins: [O3DG2],
  props: {
    envMap: {}
  },
  methods: {
    async setup () {
      let mat = new WoozyMaterial()

      this.onLoop(() => {
        mat.time = window.performance.now() * 0.001
      })

      mat.envMap = this.ctx.cubeCam.out.envMap
      this.ctx.cubeCam.add(this.o3d)

      // this.jellyfish = require('file-loader!./glb/jellyfish-simple.glb')
      let stuff = await loadGLTF(this.jellyfish)

      stuff.scene.traverse((item) => {
        if (item.isMesh) {
          item.material = mat
        }
      })

      // this.o3d.position.y = 18
      stuff.scene.position.z = -18
      stuff.scene.scale.x = 30
      stuff.scene.scale.y = 30
      stuff.scene.scale.z = 30
      this.onLoop(() => {
        stuff.scene.rotation.y += 0.01
      })
      this.o3d.add(stuff.scene)
    }
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>

</style>